module.exports = __webpack_public_path__ + "static/media/calculatorForSocialSecurity.1aaf5ec2.jpg";